import script from "./NavbarTop.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarTop.vue?vue&type=script&setup=true&lang=js"

import "./NavbarTop.vue?vue&type=style&index=0&id=0ce2ffab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce2ffab"]])

export default __exports__